import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Button,
  Collapse,
  CircularProgress,
} from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddDocument from "./AddDocument";
import { useMutation } from "react-query";
import { deleteDocument, getUploadedDocuments, viewActivityFile } from "../../services";
import { useParams } from "react-router-dom";
import moment from "moment";
import { DocumentsListType } from "./types";
import usePopup from "../../../hooks/usePopup";
import { UploadDocumentContext } from ".";
import useAuthentication from "@hooks/useAuthentication";
const DocumentsList: FC<{files?:string,submission?:boolean}> = ({files="image/*,application/pdf,video/*",submission=false}) => {
  const { showSnackbar } = usePopup();
  const { encounterId } = useParams();
  const {user} = useAuthentication()
  const {setRefetch,refetch} = useContext(UploadDocumentContext)
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(-1);
  const [fileLoading,setFileLoading] = useState(-1)
  const {
    mutate: fetchDocumentList,
    isLoading: listLoading,
    data: documentList,
  } = useMutation(getUploadedDocuments,{
    onSuccess:(result)=>{
        if(result.responseIndicator == "success"){
           setRefetch(false)
        }
    }
  });
  const closeCollapse = () => {
    setOpen(false);
  };

  const { mutate: ViewFile, } = useMutation(
    viewActivityFile,
    {
      onSuccess: (result) => {
        if (result.responseIndicator === "success") {
          const filePath = result.response?.file;
          const content = result.response?.content; // Base64 encoded content
          let extension = "";
      
          if (filePath && content) {
            const split = filePath.split(".");
            extension = split.length > 1 ? split[split.length - 1] : "";
      
            const mime = mimeTypes[extension as keyof typeof mimeTypes] || "application/octet-stream";
      
            try {
              const binaryContent = atob(content);
              const byteArray = new Uint8Array(binaryContent.length);
              for (let i = 0; i < binaryContent.length; i++) {
                byteArray[i] = binaryContent.charCodeAt(i);
              }
              const blob = new Blob([byteArray], { type: mime });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl, "_blank");
              setFileLoading(-1)
            } catch (error) {
              showSnackbar({
                message: "Failed to process the file.",
                open: true,
                variant: "error",
                duration: 2000,
              });
            }
          } else {
            showSnackbar({
              message: result.responseMessage || "Invalid response data.",
              open: true,
              variant: "warning",
              duration: 2000,
            });
          }
        }
      },
      onError: () => {
        showSnackbar({
          message: "Failed to display file !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    }
  );

  const {mutate:deleteFile,isLoading:deleteLoading} = useMutation(deleteDocument,{
    onSuccess:(result)=>{
        if(result.responseIndicator == "success"){
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"success",
            duration:2000
          })
          setRefetch(true)
        }else{
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"warning",
            duration:2000
          })
        }
    },
    onError:()=>{
      showSnackbar({
        message:"Something went wrong !",
        open:true,
        variant:"warning",
        duration:2000
      })
    }
  })

  const handleDelete = (row: DocumentsListType, index: number) => {
    setSelected(index);
    deleteFile(row.id)
  };

  const handleViewFile = (row: DocumentsListType,index:number) => {
    setFileLoading(index)
    ViewFile({
      bodyImg: row.uploadFile,
      id: row.id,
      clinicId:Number(user?.clinicId)
    });
  };

  useEffect(() => {
     if(refetch){
      fetchDocumentList(encounterId as string);
     }
  }, [refetch]);
  return (
    <TableContainer className="border">
      <Table size="small" aria-label="simple table">
        <TableHead>
          <TableRow
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            {headings.map((title, index) => (
              <TableCell
                key={index}
                sx={(theme) => ({ color: theme.palette.background.paper })}
              >
                {title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="right" colSpan={headings.length}>
              {!open && (
                <Button
                  color="success"
                  endIcon={<AddCircleIcon />}
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  add
                </Button>
              )}
              <Collapse in={open}>
                <AddDocument close={closeCollapse} files={files} submission={submission}/>
              </Collapse>
            </TableCell>
          </TableRow>
          {listLoading ? (
            <TableRow>
              <TableCell align="right" colSpan={headings.length}>
                Loading... <CircularProgress size={20} />{" "}
              </TableCell>
            </TableRow>
          ) : (
            (documentList?.response || []).map((row, index) => (
              <TableRow key={row.id}>
                <TableCell width={90}>{index + 1}</TableCell>
                <TableCell>{row.documents}</TableCell>
                <TableCell>
                  {moment(row.createdDate).format("DD-MM-YYYY hh:mm A")}
                </TableCell>
                <TableCell width={180}>
                  <Tooltip title="View">
                    <IconButton
                      disabled={fileLoading == index}
                      color="primary"
                      onClick={() => {
                        handleViewFile(row,index);
                      }}
                    >
                     {(fileLoading==index)? <CircularProgress size={18} color="primary" /> : <RemoveRedEyeIcon />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      disabled={deleteLoading}
                      color="error"
                      onClick={() => {
                        handleDelete(row, index);
                      }}
                    >
                      {deleteLoading && index == selected ? (
                        <CircularProgress size={18} color="error" />
                      ) : (
                        <DeleteIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DocumentsList;

const headings = ["Sl no", "Document name", "Created Date", "Action"];

const mimeTypes = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  bmp: "image/bmp",
  webp: "image/webp",
  "svg+xml": "image/svg+xml",
  ico: "image/x-icon",
  mp4: "video/mp4",
  webm: "video/webm",
  ogg: "video/ogg",
  "x-msvideo": "video/x-msvideo",
  mpeg: "video/mpeg",
  plain: "text/plain",
  html: "text/html",
  json: "application/json",
  csv: "text/csv",
  xml: "text/xml",
  css: "text/css",
  js: "text/javascript",
  markdown: "text/markdown",
  pdf: "application/pdf",
  msword: "application/msword",
  "vnd.ms-excel": "application/vnd.ms-excel",
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.ms-powerpoint": "application/vnd.ms-powerpoint",
  "vnd.openxmlformats-officedocument.presentationml.presentation":
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  wav: "audio/wav",
  aac: "audio/aac",
  mp3: "audio/mpeg",
  zip: "application/zip",
  tar: "application/x-tar",
  "x-7z-compressed": "application/x-7z-compressed",
  rar: "application/vnd.rar",
  jsonld: "application/ld+json",
  yaml: "text/yaml",
};



